import React from 'react';

import { Job } from '@hud/portal-dtos/pr-comparisons.dto';
import { Container } from '@hud/web-components/Container/Container';
import DataColumns from '@hud/web-components/DataColumns/DataColumns';
import { formatDateTime } from '@hud/web-components/utils';

export interface JobOverviewProps {
  job?: Job;
  loading: boolean;
}

export default function JobOverview({ job, loading }: JobOverviewProps) {
  return (
    <Container title="Overview" variant="solid" aria-label="Job Overview">
      <DataColumns.Columns>
        <DataColumns.Column>
          <DataColumns.Row title="Job ID" loading={loading}>
            {job ? job.id : null}
          </DataColumns.Row>
          <DataColumns.Row title="PR ID" loading={loading}>
            {job ? job.prId : null}
          </DataColumns.Row>
          <DataColumns.Row title="Started at" loading={loading}>
            {job?.startedAt ? formatDateTime(job.startedAt, false) : '-'}
          </DataColumns.Row>
          <DataColumns.Row title="Ended at" loading={loading}>
            {job?.endedAt ? formatDateTime(job.endedAt, false) : '-'}
          </DataColumns.Row>
          <DataColumns.Row title="Architecture" loading={loading}>
            {job?.architecture}
          </DataColumns.Row>
        </DataColumns.Column>
      </DataColumns.Columns>
    </Container>
  );
}
